// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'
import moment from 'moment'
import jQuery from 'jquery'
import vSelect from 'vue-select'
import InputTag from 'vue-input-tag'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import VueTheMask from 'vue-the-mask'
import numeral from 'numeral'
import VueGoodTablePlugin from 'vue-good-table'

import 'es6-promise/auto'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import ToggleButton from 'vue-js-toggle-button'

import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'vue-good-table/dist/vue-good-table.css'

const options = {
  color: '#bffaf3',
  failedColor: '#874b4b',
  thickness: '30px',
  transition: {
    speed: '0.1s',
    opacity: '0.6s',
    termination: 6000
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}
jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle'
  }
})

Vue.config.productionTip = false
Vue.use(VueProgressBar, options)
Vue.use(BootstrapVue)
Vue.use(VueChartkick, {adapter: Chart})
Vue.use(ToggleButton)
Vue.use(datePicker)
Vue.use(VueGoodTablePlugin)

Vue.component('v-select', vSelect)
Vue.component('input-tag', InputTag)

Vue.filter('date', function (v) {
  return v ? moment(v).format('YYYY-MM-DD') : ''
})
Vue.filter('datetime', function (v) {
  return v ? moment(v).format('YYYY-MM-DD hh:mm a') : ''
})
Vue.filter('toNumber', function (value) {
  return numeral(value).format('0,0')
})
Vue.filter('toPct', function (value) {
  return numeral(value).format('0.00')
})
Vue.filter('toCurrency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  return new Intl.NumberFormat('en-IN').format(value)
})
Vue.use(VueTheMask)
Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
  baseUrl: '', // Your API domain

  providers: {
    google: {
      name: 'google',
      url: '/auth/google-login',
      authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
      redirectUri: `${window.location.protocol}//${window.location.host}`,
      requiredUrlParams: ['scope'],
      optionalUrlParams: ['display'],
      scope: ['profile', 'email'],
      scopePrefix: 'openid',
      scopeDelimiter: ' ',
      display: 'popup',
      oauthType: '2.0',
      clientId: '96447791216-hm10lhs8pajhoefnca4g2nmmjmprp7ii.apps.googleusercontent.com',
      popupOptions: { width: 452, height: 633 }
    }
  }
})
/* eslint-disable no-new */
let app = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  if (store.state.loggedIn) {
    // do nothing
    console.log('Allow', to.path)
  } else {
    if (to.path !== '/login') {
      console.log('Deny', to.path)
      next('login')
    }
  }
  next()
})

// Intercept all requests
axios.interceptors.request.use(
  (config) => {
    // do something before sending requests
    app.$Progress.start()
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Intercept all responses
axios.interceptors.response.use(
  (response) => {
    // when success from server
    app.$Progress.finish()
    return response
  },

  (error) => {
    // when error from server
    app.$Progress.fail()
    return Promise.reject(error)
  }
)

const MAX_REQUESTS_COUNT = 2
const INTERVAL_MS = 50
let PENDING_REQUESTS = 0
/**
 * Axios Request Interceptor
 */
axios.interceptors.request.use(function (config) {
  return new Promise((resolve, reject) => {
    let interval = setInterval(() => {
      if (config.method === 'get') {
        console.log('ALLOW GET', config.url, PENDING_REQUESTS, 'max allowed', MAX_REQUESTS_COUNT)
        clearInterval(interval)
        resolve(config)
      } else if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
        PENDING_REQUESTS++
        clearInterval(interval)
        resolve(config)
      } else {
        console.log('Pending Requests', config.method, config.url, PENDING_REQUESTS, 'max allowed', MAX_REQUESTS_COUNT)
      }
    }, INTERVAL_MS)
  })
})

/**
 * Axios Response Interceptor
 */
axios.interceptors.response.use(function (response) {
  PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
  return Promise.resolve(response)
}, function (error) {
  PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1)
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/main.js